// ================================
// SOCKET CONTEXT - REAL TIME
// ================================
import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const { user, role } = useAuth();

  useEffect(() => {
    if (!user) return;

    const s = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000', {
      transports: ['websocket']
    });

    s.on('connect', () => {
      console.log('🔌 Socket connected');
      // Join the right room based on role
      if (role === 'admin')    s.emit('join:admin');
      if (role === 'driver')   s.emit('join:driver', user.name);
      if (role === 'customer') s.emit('join:customer', user.mid);
      if (role === 'staff')    s.emit('join:staff', user.username);
    });

    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, [user, role]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
